/* US Multi campaign UI guard. Shopify BXGY, not this script, enforces pricing. */
(() => {
  'use strict';
  const ID = '312359';
  const MULTI = '31659579113581';
  const QUALIFIERS = new Set([MULTI, '12110746157165', '39591522893933']);
  const END = Date.parse('2026-10-30T05:00:00Z');
  const attached = new WeakSet();
  const widgets = new Set();
  const watchedPopups = new WeakSet();
  let pending = false;
  let pendingTimer;
  function canOffer(current) {
    if (window.Shopify?.country !== 'US' || Date.now() >= END) return false;
    const items = window.Rebuy?.Cart?.items?.();
    if (!Array.isArray(items)) return false;
    let qualifying = 0;
    let oneTimeMulti = 0;
    for (const item of items) {
      const id = String(item.variant_id || item.id);
      const quantity = Number(item.quantity) || 0;
      if (QUALIFIERS.has(id)) qualifying += quantity;
      if (id === MULTI && !item.selling_plan_allocation && !item.selling_plan) oneTimeMulti += quantity;
    }
    // Any existing eligible pair already receives the single native discount.
    if (qualifying < 1 || (qualifying >= 2 && oneTimeMulti >= 1)) return false;
    return Boolean(current?.data?.metadata?.matched_rules?.length) &&
      current.data.products?.some(product => String(product.id) === '4451932864621');
  }
  function releasePending() {
    pending = false;
    clearTimeout(pendingTimer);
  }
  function attach(current) {
    if (!current || String(current.id) !== ID || attached.has(current)) return;
    attached.add(current);
    widgets.add(current);
    const originalShow = current.show;
    const originalAdd = current.addToCart;
    current.show = function (...args) {
      if (!pending && canOffer(this)) return originalShow.apply(this, args);
    };
    current.addToCart = function (product, callback) {
      if (pending || !canOffer(this)) return;
      pending = true;
      pendingTimer = setTimeout(releasePending, 30000);
      try {
        return originalAdd.call(this, product, (...args) => {
          releasePending();
          if (typeof callback === 'function') callback(...args);
        });
      } catch (error) {
        releasePending();
        throw error;
      }
    };
  }
  function watchPopup(current) {
    if (!current || String(current.id) !== ID) return;
    const popup = document.getElementById(`rebuy-widget-${ID}`)
      ?.querySelector('.rebuy-widget-container.widget-display-popup');
    if (!popup || watchedPopups.has(popup)) return;
    watchedPopups.add(popup);
    // Vendor cart listeners can update visibility after this script's listener.
    // Recheck only this popup's rendered visibility; never alter cart/pricing.
    new MutationObserver(() => {
      if (current.data?.visible && !canOffer(current)) current.hide();
    }).observe(popup, { attributes: true, attributeFilter: ['class'] });
  }
  for (const eventName of ['rebuy.init', 'rebuy.beforeReady', 'rebuy.ready']) {
    document.addEventListener(eventName, event => {
      attach(event.detail?.widget);
      watchPopup(event.detail?.widget);
    });
  }
  document.addEventListener('rebuy.add', event => {
    const current = event.detail?.widget;
    if (String(current?.id) !== ID) return;
    releasePending();
    current.hide();
    window.Rebuy?.SmartCart?.show?.();
  });
  document.addEventListener('rebuy:cart.change', () => {
    // Rebuy may mount this campaign in more than one integration context.
    // Close every attached instance once the cart no longer qualifies.
    for (const current of widgets) {
      if (current?.data?.visible && !canOffer(current)) current.hide();
    }
  });
  for (const current of window.Rebuy?.widgets || []) {
    attach(current);
    watchPopup(current);
  }
})();
